import http from "../../http-common";
/**
 * Author : AndréK
 * 26/08/2022
*/

//Client
const createClient = (data) => {
    return http.post("/Client/InsertClient", data);
};

const getClient = (data) => {
    return http.post("/Client/FilterClient", data);
};

const updateClient = (data) => {
    return http.post("/Client/UpdateClient", data);
};

//Address
const createClientAddress = (data) => {
    return http.post("/Client/InsertClientAddress", data);
};

const getClientAddress = (data) => {
    return http.post("/Client/FilterClientAddress", data);
};

const updateClientAddress = (data) => {
    return http.post("/Client/UpdateClientAddress", data);
};

//Email
const createClientEmail = (data) => {
    return http.post("/Client/InsertClientEmail", data);
};

const getClientEmail = (data) => {
    return http.post("/Client/FilterClientEmail", data);
};

const updateClientEmail = (data) => {
    return http.post("/Client/UpdateClientEmail", data);
};

//Phone
const createClientPhone = (data) => {
    return http.post("/Client/InsertClientPhone", data);
};

const getClientPhone = (data) => {
    return http.post("/Client/FilterClientPhone", data);
};

const updateClientPhone = (data) => {
    return http.post("/Client/UpdateClientPhone", data);
};

//Impressora
const createClientPrinter = (data) => {
    return http.post("/Client/InsertClientPrinter", data);
};

const getClientPrinter = (data) => {
    return http.post("/Client/FilterClientPrinter", data);
};

const updateClientPrinter = (data) => {
    return http.post("/Client/UpdateClientPrinter", data);
};


export default {
    createClient,
    getClient,
    updateClient,
    createClientAddress,
    getClientAddress,
    updateClientAddress,
    createClientEmail,
    getClientEmail,
    updateClientEmail,
    createClientPhone,
    getClientPhone,
    updateClientPhone,
    createClientPrinter,
    getClientPrinter,
    updateClientPrinter
};
